import { useApi, githubAuthApiRef } from '@backstage/frontend-plugin-api';
import { Octokit } from '@octokit/rest';
import useAsync from 'react-use/esm/useAsync';
import type { Codespace } from '../types';
import { fetchCodespaces, fetchRepositoryCodespaces } from './codespacesClient';
import type { RepoRef } from '../utils/entityRepoRef';

const GITHUB_CODESPACES_SCOPE = 'codespace';

export function useCodespaces() {
  const githubAuthApi = useApi(githubAuthApiRef);
  return useAsync(async (): Promise<Codespace[]> => {
    const token = await githubAuthApi.getAccessToken(GITHUB_CODESPACES_SCOPE);
    const octokit = new Octokit({ auth: token });

    return fetchCodespaces(octokit);
  }, [githubAuthApi]);
}

export function useRepositoryCodespaces(repoRef: RepoRef | undefined) {
  const githubAuthApi = useApi(githubAuthApiRef);
  return useAsync(async (): Promise<Codespace[]> => {
    if (!repoRef) {
      return [];
    }

    const token = await githubAuthApi.getAccessToken(GITHUB_CODESPACES_SCOPE, {
      optional: true,
    });
    if (!token) {
      return [];
    }

    const octokit = new Octokit({ auth: token });
    return fetchRepositoryCodespaces(octokit, repoRef);
  }, [githubAuthApi, repoRef?.owner, repoRef?.repo]);
}
